
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import Trans from "next-translate/Trans";
import Image from "next/image";
import { NextSeo } from "next-seo";
import Layout from "@/components/core/Layout";
import Input from "@/components/common/form/Input";
import InputCheckbox from "@/components/common/form/InputCheckbox";
import InputPassword from "@/components/common/form/InputPassword";
import MiniConsultantCard from "@/components/common/MiniConsultantCard";
import Alert from "@/components/common/Alert";
import useRegister from "@/common/hook/auth/useRegister";

const Register = () => {
  const { t } = useTranslation("auth");
  const router = useRouter();
  const { onSubmit, error, register, errors, loading } = useRegister();

  return (
    <Layout className="flex" hasFooter={false}>
      <NextSeo title={t`title.register`} />
      <div className="mx-auto lg:py-28">
        <div className="relative lg:w-[587px]">
          <Image
            src="/register/background.png"
            alt="Background Image"
            layout="fill"
            placeholder="blur"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII="
            className="!hidden lg:!block"
          />
          <div className="relative py-12 px-4 lg:px-12">
            <div className="mb-12 text-center font-title text-3xl">{t`title-register.customer`}</div>
            <MiniConsultantCard />
            <form onSubmit={onSubmit} className="flex flex-col items-start">
              {error && <Alert>{error}</Alert>}
              <Input
                id="username"
                label={t`username.label`}
                rules={{ required: true, minLength: 3 }}
                placeholder={t`username.placeholder`}
                register={register}
                autoComplete="username"
              >
                {errors.username &&
                  (errors.username.type === "required"
                    ? t`common:error.required`
                    : t("common:error.min-length", { length: 3 }))}
              </Input>
              <Input
                id="email"
                placeholder={t`common:email.placeholder`}
                register={register}
                rules={{ required: true, pattern: /^\S+@\S+$/i }}
                label={t`common:email.label`}
                className="mt-6"
                type="email"
                autoComplete="email"
              >
                {errors.email &&
                  (errors.email.type === "required" ? t`common:error.required` : t`common:error.valid-email`)}
              </Input>
              <InputPassword
                id="password"
                placeholder={t`common:password.placeholder`}
                register={register}
                rules={{ required: true, minLength: 8 }}
                label={t`common:password.label`}
                className="mt-6"
                isNewPassword
              >
                {errors.password &&
                  (errors.password.type === "required"
                    ? t`common:error.required`
                    : t("common:error.min-length", { length: 8 }))}
              </InputPassword>
              <InputCheckbox
                register={register}
                rules={{ required: true }}
                className="mt-6 items-start text-xs"
                id="agreement"
                hasError={!!errors.agreement}
              >
                <Trans
                  i18nKey="auth:contract"
                  components={{
                    terms: (
                      // eslint-disable-next-line jsx-a11y/control-has-associated-label
                      <button
                        type="button"
                        className="underline hover:text-blue"
                        onClick={() => router.push("/terms-and-conditions")}
                      />
                    ),
                    privacy: (
                      // eslint-disable-next-line jsx-a11y/control-has-associated-label
                      <button
                        type="button"
                        className="underline hover:text-blue"
                        onClick={() => router.push("/privacy-policy")}
                      />
                    ),
                  }}
                />
              </InputCheckbox>
              <button
                type="submit"
                className="button hover-orange mt-12 w-full self-end text-lg font-semibold"
                disabled={loading}
              >
                {loading ? <div className="spinner" /> : t`auth:button.register`}
              </button>
            </form>
            <div className="mt-12 text-sm text-grey-800">
              <Trans
                i18nKey="auth:redirect.login"
                components={{
                  redirect: (
                    // eslint-disable-next-line jsx-a11y/control-has-associated-label
                    <button
                      type="button"
                      className="font-semibold text-orange hover:text-orange-900"
                      onClick={() =>
                        router.push(router.query.redirectTo ? { pathname: "/login", query: router.query } : "/login")
                      }
                    />
                  ),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

const __Page_Next_Translate__ = Register;


    export default __appWithI18n(__Page_Next_Translate__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
    });
  